import React, { useCallback } from 'react';
import { Error } from 'src/components/form/Select';
import { DefaultTheme } from 'styled-components';
import { ActionMeta, Props, Theme } from 'react-select';
import { useAssessmentsListQuery } from 'src/graphql/_generated';
import * as S from './AssessmentSelect.styles';

type Option = { label: string; value: string };

interface AssessmentSelectProps extends Omit<Props<Option>, 'value'> {
  theme?: Theme & DefaultTheme;
  value?: string;
  onChange?: (value: Option, meta: ActionMeta<Option>) => void;
  placeholder?: string;
}

export const AssessmentSelect: React.FC<AssessmentSelectProps> = ({
  value,
  placeholder = 'Select Assessment',
  ...other
}) => {
  const { data } = useAssessmentsListQuery();

  const options =
    data?.assessments.map((el) => {
      return {
        label: el.name,
        value: el.id as string,
      };
    }) || [];

  const getOptionValue = useCallback((option: Option) => option.value, []);
  return (
    <div data-cy="assessment-select">
      <S.StyledSelect
        value={options.find((el) => el.value === value)}
        getOptionValue={getOptionValue}
        placeholder={placeholder}
        options={options}
        {...other}
      />
      {other.error && other.helperText && <Error>{other.helperText}</Error>}
    </div>
  );
};
